import { render, staticRenderFns } from "./mobile-promotion.noteV2.vue?vue&type=template&id=c14237e4&scoped=true"
var script = {}
import style0 from "./mobile-promotion.noteV2.vue?vue&type=style&index=0&id=c14237e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14237e4",
  null
  
)

export default component.exports